(function () {
  'use strict';

  // Cards beyond "Products visible" are rendered with [hidden] already set by the section's Liquid.
  // "Load more" simply removes it - no fetch, no pagination, so it works the same whether the grid
  // was filled from "Product card" blocks, a collection, or Shopify's own recommendations below.
  class Pdp1970eGrid extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (url) {
        this.load(url);
      } else {
        this.setup();
      }
    }

    load(url) {
      var self = this;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (markup) {
          var doc = document.createElement('div');
          doc.innerHTML = markup;
          // Same-origin fetch of this store's own recommendations endpoint, rendered by our own
          // escaped Liquid (see the section file) - not third-party or user-supplied markup.
          var fresh = doc.querySelector('pdp1970e-grid');
          if (fresh && fresh.querySelector('.pdp1970e__card')) {
            self.innerHTML = fresh.innerHTML;
          }
          self.setup();
        })
        .catch(function () { self.setup(); });
    }

    setup() {
      var list = this.querySelector('[data-pdp1970e-list]');
      this.list = list;

      var loadMore = this.querySelector('[data-pdp1970e-load-more]');
      if (loadMore) {
        var hiddenCards = list ? Array.prototype.slice.call(list.querySelectorAll('.pdp1970e__card[hidden]')) : [];
        if (hiddenCards.length) {
          loadMore.hidden = false;
          loadMore.addEventListener('click', function () {
            hiddenCards.forEach(function (card) { card.hidden = false; });
            hiddenCards = [];
            loadMore.hidden = true;
          });
        } else {
          loadMore.hidden = true;
        }
      }

      this.querySelectorAll('[data-pdp1970e-scroll]').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          if (!list) return;
          var direction = Number(arrow.getAttribute('data-pdp1970e-scroll'));
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          list.scrollBy({ left: direction * list.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    }
  }

  if (!customElements.get('pdp1970e-grid')) customElements.define('pdp1970e-grid', Pdp1970eGrid);
})();
